import * as type from "./types";
import { createReducer } from "../../util/index";

const initialState = {
    // data: [],
};

const dashboardReducer = createReducer(initialState) ({
    [type.GET_DASHBOARD]: (state, action) => ({
        ...state,
        dashboard_data: action.payload
    })
});

export default dashboardReducer;